import {IFetchContext} from "@pg-mono/data-fetcher";
import {IVendorDetailActiveOffersParams} from "@pg-mono/rp-routes/src/types/IVendorDetailActiveOffersParams";

import {rpApi} from "../../app/api/rp_api";
import {IRPRequestMeta} from "../../app/rp_request_meta";
import {offerUrlConstants} from "../../offer/helpers/friendly_offer_list/offer_url_constants";
import {OfferDisplayType} from "../../offer/helpers/OfferDisplayType";
import {OfferType} from "../../offer/types/OfferType";
import {IAppDispatch, IRootState} from "../../store/store";
import {getVendorDetailAllActiveOffers} from "../api/get_vendor_detail_all_active_offers";
import {getVendorDetailOfferListMap} from "../api/get_vendor_detail_offer_list_map";
import {VENDOR_DETAIL_OFFERS_MAX_PAGE_SIZE} from "../constants/vendor_detail_offers_max_page_size";
import {initVendorDetailFilters} from "../state/vendor_offer_list_slice";
import {convertToVendorDetailViewOffersPayload} from "../utils/convert_to_vendor_detail_view_offers_payload";

export const vendorOfferDetailViewAction =
    (ctx: IFetchContext<IRPRequestMeta, IVendorDetailActiveOffersParams>) => async (dispatch: IAppDispatch, getState: () => IRootState) => {
        const {vendorId} = ctx.match.params;
        const {lokalizacja, typ} = ctx.route.query as {lokalizacja?: string; typ?: string};
        const locationSlug = lokalizacja ?? null;
        const offerType = typ ? (offerUrlConstants.types[typ] as OfferType) : null;

        const cities = getState().vendor.detail.cities;

        let region: number | null = null;
        if (locationSlug && cities) {
            const foundCity = cities.find((city) => city.slug === locationSlug);
            if (foundCity) {
                region = foundCity.id;
            }
        }

        dispatch(initVendorDetailFilters({region, offerType}));

        const fullQuery = {
            ...convertToVendorDetailViewOffersPayload({
                vendorId: parseInt(vendorId),
                region,
                displayType: OfferDisplayType.FOR_SALE,
                type: offerType ?? undefined,
                pageSize: VENDOR_DETAIL_OFFERS_MAX_PAGE_SIZE
            }),
            page: 1
        };

        await dispatch(getVendorDetailAllActiveOffers.endpoints.getVendorDetailAllActiveOffers.initiate(fullQuery));
        await dispatch(getVendorDetailOfferListMap.endpoints.getVendorDetailOfferListMap.initiate({vendor: parseInt(vendorId), region}));

        await Promise.all(dispatch(rpApi.util.getRunningQueriesThunk()));
    };
